export default {
    telemetryUrl: 'https://dc.services.visualstudio.com/v2/track',
};